import React from "react";
import { Link } from "gatsby";

const TransitionLink = (props) => {
  return <Link {...props}>{props.children}</Link>;
};

export default TransitionLink;
